<template>
    <div class="segmented-button-pair" :class="{ disabled: disabled }">
        <button
            v-for="option in options"
            :key="option.value"
            type="button"
            class="segmented-btn"
            :class="{ active: value === option.value }"
            :disabled="disabled"
            @click="$emit('input', option.value)"
        >
            {{ option.label }}
        </button>
    </div>
</template>

<script>
    export default {
        name: 'SegmentedButtonPair',
        props: {
            value: {
                type: Boolean,
                required: true,
            },
            options: {
                type: Array,
                required: true,
                validator: (opts) => opts.length === 2 && opts.every((o) => 'label' in o && 'value' in o),
            },
            disabled: {
                type: Boolean,
                default: false,
            },
        },
    };
</script>

<style scoped>
    .segmented-button-pair {
        display: inline-flex;
        border: 1px solid #d7d7d7;
        border-radius: 20px;
        overflow: hidden;
    }

    .segmented-button-pair.disabled {
        opacity: 0.5;
        pointer-events: none;
    }

    .segmented-btn {
        padding: 6px 18px;
        font-size: 13px;
        font-weight: 600;
        border: none;
        cursor: pointer;
        transition: background-color 0.2s, color 0.2s;
        background: #fff;
        color: #333;
        white-space: nowrap;
    }

    .segmented-btn:first-child {
        border-radius: 20px 0 0 20px;
    }

    .segmented-btn:last-child {
        border-radius: 0 20px 20px 0;
    }

    .segmented-btn.active {
        background-color: #5155c3;
        color: #fff;
    }

    .segmented-btn:disabled {
        cursor: not-allowed;
    }
</style>
